// const LoginPage = lazy(() => import('../pages/Login'));
// const Unauthenticated = lazy(() => import('../pages/Login/Unauthenticated'));
import LoginPage from '../pages/Login';
import Unauthenticated from '../pages/Login/Unauthenticated';

const systemRoute = {
  public: [
    {
      name: 'login',
      path: '/',
      component: LoginPage,
    },
  ],
  auth: [
    {
      name: 'unauthenticated',
      path: '/unauthenticated',
      permissions: [],
      component: Unauthenticated,
    },
    {
      name: 'unauthenticated',
      path: '/2-factor-authentication',
      permissions: [],
      component: Unauthenticated,
    },
  ],
};

export default systemRoute;
